import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse } from '@/types/api'

import type {
  AparelhoBiometria,
  CadastroAparelhoPayload,
  ConfirmacaoBiometria,
  ConfirmacaoPayload,
  DesafioCadastro,
  DesafioConfirmacao,
} from '../types/biometria'

const BASE = '/seguranca-biometria'

/** Todas as rotas valem para o usuário do token. Cada desafio é de uso único. */
export const biometriaApi = {
  opcoesCadastro: async (): Promise<DesafioCadastro> =>
    unwrap(await httpClient.post<ApiResponse<DesafioCadastro>>(`${BASE}/credenciais/opcoes`)),
  cadastrar: async (payload: CadastroAparelhoPayload): Promise<AparelhoBiometria> =>
    unwrap(await httpClient.post<ApiResponse<AparelhoBiometria>>(`${BASE}/credenciais`, payload)),
  /** 409 quando o usuário não tem nenhum aparelho cadastrado. */
  opcoesConfirmacao: async (): Promise<DesafioConfirmacao> =>
    unwrap(await httpClient.post<ApiResponse<DesafioConfirmacao>>(`${BASE}/confirmacao/opcoes`)),
  confirmar: async (payload: ConfirmacaoPayload): Promise<ConfirmacaoBiometria> =>
    unwrap(await httpClient.post<ApiResponse<ConfirmacaoBiometria>>(`${BASE}/confirmar`, payload)),
  listar: async (): Promise<AparelhoBiometria[]> =>
    unwrap(await httpClient.get<ApiResponse<AparelhoBiometria[]>>(`${BASE}/credenciais`)),
  remover: async (id: string): Promise<void> => {
    await httpClient.delete(`${BASE}/credenciais/${id}`)
  },
}
